export default __webpack_public_path__ + "static/media/addCircleIcon.696f1369.svg";